import prepareOptions from '../../prepareOptions';

export default prepareOptions([
  {
    value: { min: '2', max: '3' },
    label: '2/3',
  },
  {
    value: { min: '4', max: '5' },
    label: '4/5',
  },
  {
    value: { min: '6', max: '7' },
    label: '6/7',
  },
]);
